import "./CustomToast.css";
import { IconButton, Snackbar, SnackbarOrigin, VariantProp } from "@mui/joy";
import { CloseRounded } from "@mui/icons-material";
export type ColorNotificacion = "danger" | "success" | "warning" | "neutral" | "primary";

export interface NotificationProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  label?: string;
  color?: "danger" | "success" | "warning" | "neutral" | "primary";
  variant?: VariantProp;
  position?: SnackbarOrigin;
  duration?: number; //? in miliseconds
}
export const CustomToast: React.FC<NotificationProps> = ({
  open,
  setOpen,
  label,
  color,
  variant = "outlined",
  position = { vertical: "top", horizontal: "center" },
  duration = 5000,
}) => {
  return (
    <Snackbar
      open={open}
      onClose={() => setOpen(false)}
      variant={variant}
      color={color}
      anchorOrigin={position}
      autoHideDuration={duration}
      endDecorator={
        <IconButton onClick={() => setOpen(false)} size="sm" variant={"plain"} color={color}>
          <CloseRounded />
        </IconButton>
      }
    >
      {label}
    </Snackbar>
  );
};

export default CustomToast;
